module.exports = __webpack_public_path__ + "static/Ruslan-blur-185d3bb4e59337023139560325a9843c.jpg";